module.exports = __webpack_public_path__ + "static/img/lightbulb.d8bc14f9.png";